import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AmazonFinanceValidationResult } from 'gung-standard';
import {
  JeevesConfiguration,
  JeevesConfigurationView,
  JeevesReference,
  JeevesReferenceValidation
} from '../../models/jeeves-amazon-finance.models';

@Injectable({ providedIn: 'root' })
export class JeevesAmazonFinanceService {
  private readonly baseUrl = 'json/amazon/v2/finance/jeeves';

  constructor(private readonly http: HttpClient) {}

  getConfiguration(): Observable<JeevesConfigurationView> {
    return this.http.get<JeevesConfigurationView>(`${this.baseUrl}/configuration`);
  }

  validateConfiguration(configuration: JeevesConfiguration): Observable<AmazonFinanceValidationResult> {
    return this.http.post<AmazonFinanceValidationResult>(`${this.baseUrl}/configuration/validate`, configuration);
  }

  saveConfiguration(configuration: JeevesConfiguration): Observable<JeevesConfigurationView> {
    return this.http.put<JeevesConfigurationView>(`${this.baseUrl}/configuration`, configuration);
  }

  validateReferences(): Observable<JeevesReferenceValidation> {
    return this.http.get<JeevesReferenceValidation>(`${this.baseUrl}/references/validation`);
  }

  findCustomers(query: string, limit = 20): Observable<JeevesReference[]> {
    return this.findReferences('customers', query, limit);
  }

  findProducts(query: string, limit = 20): Observable<JeevesReference[]> {
    return this.findReferences('products', query, limit);
  }

  private findReferences(type: 'customers' | 'products', query: string, limit: number) {
    const params = new HttpParams().set('query', query).set('limit', limit);
    return this.http.get<JeevesReference[]>(`${this.baseUrl}/references/${type}`, { params });
  }
}
